<!--<input type="text" class="form-control" [(ngModel)]="searchValue" placeholder="Carca..." (keyup)="doSearch()" />
<select class="form-control" [ngModel]="selModel" (ngModelChange)="change($event)">
    <option [ngValue]="-1">Seleziona</option>
    <option *ngFor="let el of elements" [ngValue]="el.id">{{ el.text }}</option>
</select>-->




<div class="select-search" >
    <div  class="form-control select-search-button" (click)="dropdownclicked()">
        {{ current.text }}
    </div>
    <ul *ngIf="showList" class="select-search-menu">
        <li>
            <div *ngIf="hasCancelButton">
                <div class="col-sm-10 col-md-10 col-lg-10">
                    <input appMyAutofocus type="text" class="form-control select-search-input" [(ngModel)]="searchValue" placeholder="Cerca..." (keyup)="doSearch()" />
                </div>
                <div class="col-sm-2 col-md-2 col-lg-2">
                    <div class="btn btn-primary btn-rounded fullWidth" (click)="doCancel()">ANNULLA</div>
                </div>
                <div style="clear:both;"></div>
            </div>
            <input appMyAutofocus *ngIf="!hasCancelButton" type="text" class="form-control select-search-input" [(ngModel)]="searchValue" placeholder="Cerca..." (keyup)="doSearch()" />
        </li>
    </ul>
    <ul *ngIf="showList" class="select-search-menu select-search-data">
        
        <li *ngFor="let el of elements">
            <a class="select-search-item" (click)="selectElement(el)">{{ el.text }}</a>
        </li>
    </ul>
    <div style="margin-bottom:10px;"></div>
</div>